import React from 'react';
import { connect } from 'react-redux';

// Popup imports
class NoWebGL extends React.Component {
    render = () => {
        const { popup } = this.props;

        return (
            <div>
                <h1>
                    De browser wordt niet ondersteund.
                </h1>
                <p>
                    Helaas wordt de browser (versie) die je gebruikt niet ondersteund.<br/>
                    Probeer de browser te updaten, of een andere browser te gebruiken als dat mogelijk is.
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(
    mapStateToProps
)(NoWebGL);